import React, { useEffect, useState, useContext } from 'react';
import { PageContext } from 'src/context/PageContext';
import { useIsEmbed } from 'utils/useIsEmbed';

export interface Props {
  children?: React.ReactNode;
}

// CONSIDER: this components adjusts the minHeight of the body content to ensure the footer is always at the bottom of the page.
// perhaps this could be refactored to be a margin top on the footer instead.
export function BodyContent(props: Props) {
  const { children } = props;
  const { userInteraction } = useContext(PageContext);
  const { isEmbed } = useIsEmbed();
  // calculate min height = 100vh - (header height + footer height)
  const [bodyHeight, setBodyHeight] = useState('calc(min(100dvh, 100vh) - 230px)');
  useEffect(() => {
    const UpdateHeight = () => {
      if (isEmbed) {
        // don't set min height if is embed
        setBodyHeight('');
        return;
      }
      let height = 0;
      const headers = document.querySelectorAll('header');
      headers.forEach((header) => {
        height += header.getBoundingClientRect().height + 24; // add 24px padding
      });
      const footers = document.querySelectorAll('footer');
      footers.forEach((footer) => {
        height += footer.getBoundingClientRect().height;
      });
      // also include any special banners
      const optionalBanners = document.querySelectorAll('.optionalBanner');
      optionalBanners.forEach((banner) => {
        height += banner.getBoundingClientRect().height;
      });
      setBodyHeight(`calc(min(100dvh, 100vh) - ${height}px)`);
    };
    setTimeout(UpdateHeight, 100); // add delay to ensure all banners have updated
    window.addEventListener('resize', UpdateHeight);
    return () => {
      window.removeEventListener('resize', UpdateHeight);
    };
  }, [userInteraction, isEmbed]);

  return (
    <div style={{ minHeight: bodyHeight }} data-testid="bodyContent">
      {children}
    </div>
  );
}
